import * as currencies from "@dinero.js/currencies";
import { dinero, toDecimal } from "dinero.js";
import {
	isEmpty,
	isNumber,
	isUndefined,
	round,
	toNumber,
	upperCase,
} from "lodash";
import type { ChangeEvent } from "react";

export const formatPrice = (
	amount?: number,
	currency?: string,
	symbol?: string,
) => {
	if (isUndefined(amount) || isUndefined(currency)) {
		return `0.00 ${symbol || ""}`;
	}

	// Dinero only takes whole cents. Round to the nearest one rather than up:
	// ceiling every fractional amount inflated each printed total by a cent.
	return toDecimal(
		dinero({
			amount: round(amount),
			currency: currencies[upperCase(currency)],
		}),
		({ value, currency }) => `${value} ${symbol || currency.code}`,
	);
};

export const formatPriceCentsInput = (e: ChangeEvent<HTMLInputElement>) => {
	if (isEmpty(e.target.value)) {
		return null;
	}

	return Math.round(toNumber(e.target.value) * 100);
};

export const formatPriceCentsInputValue = (
	value: number | undefined | null,
) => {
	if (isNumber(value)) {
		return value / 100;
	}

	return "";
};

export const formatNumberInput = (e: ChangeEvent<HTMLInputElement>) => {
	if (isEmpty(e.target.value)) {
		return null;
	}

	return toNumber(e.target.value);
};
